import { Id } from "@planzone/dto";
import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveWbsMetaRequestPending(projects) {
      const req = getState().find((req) => match(req.projects, projects));

      return req ? req.request.isPending : false;
    },
    isRetrieveWbsMetaRequestSuccess(projects) {
      const req = getState().find((req) => match(req.projects, projects));

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveWbsMetaRequestFailure(projects) {
      const req = getState().find((req) => match(req.projects, projects));

      return req ? req.request.isFailure : false;
    },
    getWbsMeta(projects) {
      const req = getState().find((req) => match(req.projects, projects));

      return req ? req.meta : {};
    },
  };
}

export { createSelector };
